


import {Observable} from 'rxjs/Observable';
import {Params} from '@angular/router';
import {Video} from './video';
import {Encoding} from './encoding';

export enum TourTagType {
  Tour,
  Scene,
  Option,
  Video
}

export class TourTag {
  static tourTagRegEx = new RegExp('/(\\w+)/(\\w+)/(direct|onsite)');
  static videoTagRegEx = new RegExp('/(\\w+)/(\\w+)/(direct|onsite)/video/(.+)');
  type: TourTagType;
  sceneID: number;
  optionID: number;
  url: string;
  videoFilePath: string;
  builderPath: string;
  modelPath: string;
  video: Video;
  constructor(url: string, params: Observable<Params>) {
    this.url = url;
    const match = TourTag.tourTagRegEx.exec(this.url);
    this.builderPath = match[1];
    this.modelPath = match[2];

    // video tag
    if (TourTag.videoTagRegEx.test(this.url)) {

      const videoMatch = TourTag.videoTagRegEx.exec(this.url);
      const videoPath = videoMatch[4];
      if (videoPath !== null) {
        // console.log('VIDEO TAG');
        // console.log(videoPath)
        this.videoFilePath = videoPath;
        this.type = TourTagType.Video;

        this.video = new Video(null);
        const encoding = new Encoding(null);
        encoding.relUrl = videoPath;
        this.video.encodings = [encoding];
      }

      // option tag
    } else if (params['optionid'] != null && params['sceneid'] != null) {
      this.optionID = Number(params['optionid']);
      this.sceneID = Number(params['sceneid']);
      this.type = TourTagType.Option;

      // scene tag
    } else if (params['sceneid'] != null) {
      this.sceneID = Number(params['sceneid']);
      this.type = TourTagType.Scene;

    // tour
    } else {
      this.type = TourTagType.Tour;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/model/tour-tag.ts